import { getAbTestV2 } from '../utils/abTest/clientAbTestV2';

export const EMAIL_ONLY_CHECKOUT_TEST_NAME = 'emailOnlyCheckout';

export const isEmailOnlyCheckoutVariant = (): boolean =>
    getAbTestV2(EMAIL_ONLY_CHECKOUT_TEST_NAME)?.variant === 'variant';
